import { render, staticRenderFns } from "./PropertiesSection.vue?vue&type=template&id=651b50ab&"
import script from "./PropertiesSection.vue?vue&type=script&lang=js&"
export * from "./PropertiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports